import template from './sw-cms-block-acris-faq.html.twig';

const { Component } = Shopware;

Component.register('sw-cms-block-acris-faq', {
    template
});
